/**
 * Hàm thuần cho thanh tab dùng chung (`src/components/section-tabs`) — không phụ thuộc React
 * hay URL, chỉ xử lý logic chọn tab để test được độc lập.
 */

/**
 * Chọn tab đang active dựa trên danh sách tab đang có (`available`), giá trị đọc từ URL
 * (`requested`) và tab mặc định (`fallback`) khi `requested` không hợp lệ.
 * - `requested` có trong `available` -> dùng `requested`.
 * - Ngược lại, `fallback` có trong `available` -> dùng `fallback`.
 * - Ngược lại -> phần tử đầu của `available`.
 * - `available` rỗng -> `null` (không có gì để chọn).
 */
export function resolveActiveTab(
  available: string[],
  requested: string | null,
  fallback?: string
): string | null {
  if (available.length === 0) return null;
  if (requested && available.includes(requested)) return requested;
  if (fallback && available.includes(fallback)) return fallback;
  return available[0];
}

/**
 * Lọc danh sách tab còn hiển thị phía người xem, theo đúng thứ tự `order`, chỉ giữ lại
 * key có `availability[key] === true`. `undefined` nghĩa là chưa biết (còn đang tải) nên
 * CHƯA hiện — tránh nháy tab rồi biến mất ngay khi dữ liệu về.
 */
export function visibleViewerTabs(
  availability: Record<string, boolean | undefined>,
  order: string[]
): string[] {
  return order.filter((key) => availability[key] === true);
}
